// See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Errors/Cyclic_object_value
const replaceCircular = () => {
    const seen = new WeakSet();

    return (key, value) => {
        if (typeof value === 'object' && value !== null) {
            if (seen.has(value)) {
                return '<< Circular value replaced >>';
            }
            seen.add(value);
        }

        return value;
    };
};

export default replaceCircular;
